var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"nav nav-pills"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'partners' }}},[_vm._v("Partners")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'create_partner' }}},[_vm._v("New Partner")])],1),_vm._v(" "),(_vm.partnerId)?_c('li',[_c('router-link',{attrs:{"to":{ name: 'edit_partner', params: {
        partnerId: _vm.partnerId
      }}}},[_vm._v("Edit Partner")])],1):_vm._e(),_vm._v(" "),(_vm.partnerId)?_c('li',[_c('router-link',{attrs:{"to":{ name: 'partner_apps', params: {
        partnerId: _vm.partnerId
      }}}},[_vm._v("Partner Apps")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-097d21aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnerNav.vue
// module id = 1130
// module chunks = 1